import $http from '../../axios-instance';
import Swal from 'sweetalert2'


export async function listaTipoSeguimiento({ dispatch, state, rootState, commit }) {
    if (!state.tipoSeguimientos.length) {
        await dispatch('hallazgosSeguimientos/listarTipoSeguimiento', {}, { root: true })
        commit('setListarTipoSeguimiento', rootState.hallazgosSeguimientos.tipoSeguimientos)
    }
}